function getStore(vm, name) {
  const key = `${vm.usedStore}/${name}`;
  return vm.$store.getters[key];
}

function dispatch(vm, name, value) {
  return vm.$store.dispatch(`${vm.usedStore}/${name}`, value);
}

export default {
  props: {
    store: String,
  },
  inject: {
    dataTableStoreName: { default: null },
  },
  methods: {
    patch(id, patcher) {
      return dispatch(this, "patchItem", { id, patcher });
    },
    unexpand(item) {
      dispatch(this, "unexpand", item);
    },
    fetch() {
      return dispatch(this, "fetchPage");
    },
    clear() {
      return dispatch(this, "clear");
    },
    reload() {
      return dispatch(this, "reload");
    },
    expand(items) {
      return dispatch(this, "expanded", items);
    },
  },
  computed: {
    usedStore() {
      if (this.store) {
        return this.store;
      } else {
        return this.dataTableStoreName;
      }
    },
    pagination() {
      return getStore(this, "pagination");
    },
    items() {
      return getStore(this, "data");
    },
    expanded() {
      return getStore(this, "expanded");
    },
    loading() {
      return getStore(this, "loading");
    },
    unpaged() {
      return getStore(this, "unpaged");
    },
    firstSort() {
      const pagination = this.pagination;
      if (pagination.sort.length) {
        return pagination.sort[0];
      } else {
        return null;
      }
    },
    sortBy() {
      if (this.firstSort) {
        return this.firstSort.name;
      } else {
        return null;
      }
    },
    sortDesc() {
      if (this.firstSort) {
        return !this.firstSort.asc;
      } else {
        return null;
      }
    },
    itemsPerPage() {
      return this.pagination.itemsPerPage;
    },
    total() {
      return this.pagination.total;
    },
    page() {
      return this.pagination.page;
    },
  },
  render(h) {
    const _vm = this;

    const progress = h(
      "v-progress-linear",
      {
        slot: "progress",
        props: {
          indeterminate: true,
          color: "secondary",
        },
      },
      []
    );

    const pageCount = _vm.itemsPerPage > 0 ? Math.ceil(_vm.total / _vm.itemsPerPage) : 1;
    if (_vm.page > pageCount && pageCount > 0) {
      dispatch(_vm, "updatePage", pageCount);
    }


    const table = h(
      "v-data-table",
      {
        props: {
          ..._vm.$attrs,
          items: _vm.items,
          expanded: _vm.expanded,
          loading: _vm.loading,
          page: _vm.page,
          itemsPerPage: _vm.itemsPerPage,
          "server-items-length": _vm.total,
          "footer-props": {
            "items-per-page-options": [10, 20, 50],
          },
          sortBy: _vm.sortBy,
          sortDesc: _vm.sortDesc,
          "must-sort": true
        },
        scopedSlots: _vm.$scopedSlots,
        on: {
          ..._vm.$listeners,
          "update:expanded": function (expanded) {
            dispatch(_vm, "expanded", expanded);
          },
          "update:page": function (page) {
            dispatch(_vm, "updatePage", page);
          },
          "update:items-per-page": function (itemsPerPage) {
            dispatch(_vm, "updateItemsPerPage", itemsPerPage);
          },
          "update:sort-by": function (sortBy) {
            dispatch(_vm, "updateSort", [{ name: sortBy, asc: true }]);
          },
          "update:sort-desc": function (sortDesc) {
            if (_vm.sortBy) {
              dispatch(_vm, "updateSort", [{ name: _vm.sortBy, asc: !sortDesc }]);
            }
          },
        },
      },
      [progress],
    );

    return h(
      "div",
      {
        attrs: {
          class: "filter-table",
        },
      },
      [table]
    );
  },
};
